import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReportBusiness, getReportBusinessGrapth, getReportOverview } from "../../../redux/profile/action";
import MyBusiness from "./MyBusiness";
import Overview from "./Overview";

export default function DashboardReports() {
  const dashboardreportoverview = useSelector(({ profile: { dashboardreportoverview } }) => dashboardreportoverview);
  const dashboardreportbusiness = useSelector(({ profile: { dashboardreportbusiness } }) => dashboardreportbusiness);
  const dashboardreportbusinessgraph = useSelector(({ profile: { dashboardreportbusinessgraph } }) => dashboardreportbusinessgraph);
  const dispatch = useDispatch();
  
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    dispatch(getReportOverview());
    dispatch(getReportBusiness());
    // dispatch(getReportBusinessGrapth());
  }, [dispatch]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="report-sec">
      <div className="order-first">
        <h2>My Report</h2>
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "overview" ? "active" : ""}`}
              onClick={() => handleTabChange("overview")}
            >
              Overview
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "myBusiness" ? "active" : ""}`}
              onClick={() => handleTabChange("myBusiness")}
            >
              Statistics
            </a>
          </li>
        </ul>
        
        <div className="tab-content">
          <div className={`tab-pane ${activeTab === "overview" ? "active" : ""}`} id="overview">
            <Overview data={dashboardreportoverview} />
          </div>
          <div className={`tab-pane ${activeTab === "myBusiness" ? "active" : ""}`} id="MyBusiness">
            <MyBusiness data={dashboardreportbusiness} graph={dashboardreportbusinessgraph} />
          </div>
        </div>
      </div>
    </div>
  );
}
